// extracted by mini-css-extract-plugin
export var from = "news-module--from--A5dM3";
export var head = "news-module--head--jlbOa";
export var link = "news-module--link--QGhbU";
export var root = "news-module--root--MrvtO";